import { useEffect } from "react"
import types from "prop-types"
import { store } from "store"
import { setCategories } from "reduxSlices/categoriesSlice"

const SetupCategoriesInRedux = ({ categories = [] }) => {
  useEffect(() => {
    store.dispatch(setCategories(categories))
  }, [categories])

  return null
}

SetupCategoriesInRedux.propTypes = {
  categories: types.arrayOf(types.object),
}

export default SetupCategoriesInRedux
